import React__default from 'react';
import styles from '../../components/atoms/button/button.module.scss.js';
import classNames from './../../external_lib/classnames/index.js';
var ButtonVariant;
(function (ButtonVariant) {
  ButtonVariant["Primary"] = "primary";
  ButtonVariant["Secondary"] = "secondary";
  ButtonVariant["Destructive"] = "destructive";
  ButtonVariant["Link"] = "link";
  ButtonVariant["Ghost"] = "ghost";
})(ButtonVariant || (ButtonVariant = {}));
var ButtonSize;
(function (ButtonSize) {
  ButtonSize["XL"] = "xl";
  ButtonSize["LG"] = "lg";
  ButtonSize["MD"] = "md";
})(ButtonSize || (ButtonSize = {}));
function Button(_a) {
  var _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? ButtonVariant.Primary : _c,
    _d = _a.size,
    size = _d === void 0 ? ButtonSize.LG : _d,
    leftIcon = _a.leftIcon,
    rightIcon = _a.rightIcon,
    children = _a.children,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = _a.onClick,
    onClick = _f === void 0 ? function () {} : _f;
  return React__default.createElement("button", {
    className: classNames(styles.Button, styles[variant], styles[size], className),
    onClick: onClick,
    disabled: disabled
  }, leftIcon && React__default.createElement("span", {
    className: styles.IconLeft
  }, leftIcon), children, rightIcon && React__default.createElement("span", {
    className: styles.IconRight
  }, rightIcon));
}
export { ButtonSize, ButtonVariant, Button as default };
//# sourceMappingURL=index.js.map
